import { HTTPError } from 'ky'
import {
  ApiClientError,
  BadGatewayError,
  BadRequestError,
  ConflictError,
  ForbiddenError,
  GatewayTimeoutError,
  InternalServerError,
  MethodNotAllowedError,
  NotFoundError,
  ServiceUnavailableError,
  TooManyRequestsError,
  UnauthorizedError,
  UnprocessableEntityError,
} from 'shared/services/ApiClient/errors'

export const createApiError = (error: HTTPError, data?: unknown, params?: Record<string, unknown>): ApiClientError => {
  switch (error.response.status) {
    case 400:
      return new BadRequestError(error, data, params)
    case 401:
      return new UnauthorizedError(error, data, params)
    case 403:
      return new ForbiddenError(error, data, params)
    case 404:
      return new NotFoundError(error, data, params)
    case 405:
      return new MethodNotAllowedError(error, data, params)
    case 409:
      return new ConflictError(error, data, params)
    case 422:
      return new UnprocessableEntityError(error, data, params)
    case 429:
      return new TooManyRequestsError(error, data, params)
    case 500:
      return new InternalServerError(error, data, params)
    case 502:
      return new BadGatewayError(error, data, params)
    case 503:
      return new ServiceUnavailableError(error, data, params)
    case 504:
      return new GatewayTimeoutError(error, data, params)
    default:
      return new ApiClientError(error, data, params)
  }
}
